import React from 'react';
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { FormGroup, Link } from 'arag-ui-lib';
import QuestionEditActions from "../QuestionEditActions";
import { getMostRecentFile } from '../../../helpers/questions/functions';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { DROPZONE_ACCEPTED_FILES_ARRAY } from '../../../helpers/variables';
import { TERTIARY } from '../../../helpers/constants';

const UploadInputType = (props) => {
    const {
        question,
        formData,
        isPlain,
        application,
        attachments,
        hasInlineElements,
        onDrop,
        downLoadFile,
        onAttachmentRequest,
        multipleFilesAllowed = false,
        fileDisabled = false,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        openEditQuestionAnswerModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        openHistoryModal,
        isLabelClickable,
    } = props;
    const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.FILE;
    const infoText = isPlain ? null : CONTENT_STRINGS.FILES_UPLOADED_INFO;
    const attachment = getMostRecentFile(question, attachments);
    return (
        <FormGroup
            labelSize={"col-sm-3"}
            inputSize={"col-sm-6"}
            label={question.name}
            variant={variant}
            inputProps={{
                id: `question-id-${question.id}`,
                name: question.machineName,
                accepts: DROPZONE_ACCEPTED_FILES_ARRAY,
                allowMultiple: multipleFilesAllowed,
                onDrop: (files) => onDrop(files, question.id),
                label: isPlain 
                    ?
                        attachment
                        ?
                            <Link 
                                label={attachment?.name}
                                onClick={onAttachmentRequest 
                                    ? () => onAttachmentRequest(attachment)
                                    : () => downLoadFile(attachment?.name, attachment?.encodedFile)
                                } 
                                variant={TERTIARY}
                            />
                        :
                            CONTENT_STRINGS.NO_ATTACHMENT_UPLOADED
                    :   CONTENT_STRINGS.UPLOAD_FILE_TOOLTIP,
                required: question.isRequired,
                disabled: fileDisabled
            }}
            infoText={infoText}
            hasInlineElements={hasInlineElements}
            inlineGroupElements={
                hasInlineElements
                ?
                    <div className={"col-sm-3"}>
                        <QuestionEditActions
                            checkIfPlainEditable={checkIfPlainEditable(question, question.machineName)}
                            question={question}
                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                            approvalOptions={approvalOptions}
                            onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                            hasPendingChanges={checkIfQuestionHasPendingChanges( question.id, application )}
                        />
                    </div>
                :
                    null
            }
            onLabelClick={ isLabelClickable ? () => openHistoryModal(question) : undefined}
            formGroupTestId={`policy-application-${question.machineName}`}
        />
    );
};

export default UploadInputType;